import { colors } from './colors'
import { IColors } from './types'

export const primaryColor: IColors = {
  pressable: {
    borderColor: colors.gray[700],
    homeBorderColor: colors.gray[500],
    bgLoadingColor: colors.gray[600],
    bgColor: 'transparent',
    bgColorText: colors.gray[900],
    bgColorSecondaryText: 'white',
    bgDisabledColorText: colors.gray[500],
    bgIconButton: colors.gray[800],
    gradientColor: {
      gradientOne: 'white',
      gradientTwo: '#DFE4EC',
    },
    pressedGradientColor: {
      gradientOne: 'white',
      gradientTwo: '#8692A8',
    },
  },
  container: {
    bgColor: colors.gray[900],
    bgHeaderColor: colors.gray[800],
    bgStatusHomeColor: '#2D2F35',
    gradientHomeColor: {
      gradientOne: '#0C0D10',
      gradientTwo: '#4F515A',
      gradientThree: '#0C0D10',
    },
    gradientColor: {
      gradientOne: '#0C0E11',
      gradientTwo: '#07080A',
      gradientThree: '#2E303B',
    },
    gradientBottomColor: {
      gradientOne: '#101010',
      gradientTwo: '#262831',
      gradientThree: '#101010',
    },
    bgBottomTransparent: 'transparent',
  },
  checkbox: {
    bgColor: 'transparent',
    borderColor: colors.gray[500],
    checkmarkIconColor: 'black',
    checkedBgColor: colors.gray[500],
    checkedBorderColor: colors.gray[500],
    bgHoverColor: colors.gray[400]
  },
  icon: {
    primaryIconColor: 'white',
    secondaryIconColor: colors.gray[900],
    logoIconColor: '#FF8200',
    vehicleSecondaryIconColor: colors.gray[500],
    infoIconColor: colors.gray[600],
    infoModalIconColor: colors.blue[500],
    trashIconColor: colors.red[700],
    interrogationIconColor: colors.gray[700],
    memberShipColor: colors.gray[300],
    successIconColor: colors.green[500],
    errorIconColor: colors.red[500],
    starIconColor: colors.blue[500],
    startIconColor: colors.green[500],
    endIconColor: colors.red[500],
    shockDetectionOneIconColor: colors.red[700],
    shockDetectionTwoIconColor: colors.orange[700],
    shockDetectionThreeIconColor: colors.yellow[600],
    closeModalIconColor: colors.gray[700],
  },
  input: {
    bgBorderColor: colors.gray[400],
    bgTransparentBorderColor: 'transparent',
    bgColor: colors.gray[900],
    bgColorText: colors.gray[100],
    bgDisabledColorText: colors.gray[500],
    bgDisabledColor: colors.gray[900],
    bgIconButtonColor: 'transparent',
    bgIconColor: colors.gray[500],
    bgPlaceholderColor: colors.gray[500],
    labelColorText: colors.gray[400],
    bgSelectColor: colors.gray[700],
  },
  text: {
    bgColorText: 'white',
    bgColorSecondaryText: colors.gray[900],
    missingData: colors.gray[600],
    bgDisabledText: colors.gray[500],
    bgInfoColorText: colors.gray[400],
    bgPressedText: '#101010',
    smallText: colors.gray[400],
  },
  drawer: {
    bgColor: colors.gray[800],
    bgDividerColor: colors.gray[700],
    bgPressableTransparent: 'transparent',
    bgActiveGradient: {
      gradientOne: '#FFFFFF',
      gradientTwo: '#8692A8',
    },
    bgActiveColor: colors.whiteAlpha[800],
  },
  history: {
    dividerColor: colors.gray[600],
    trackColor: '#586662',
  },
  vehicle: {
    dividerColor: colors.gray[600],
  },
  slider: {
    bgFilledTrackColor: colors.green[500],
    bgThumbColor: colors.gray[100],
    bgTrackColor: colors.gray[500],
  },
  switch: {
    bgOnTrackColor: colors.gray[200],
    bgOffTrackColor: colors.gray[600],
    bgOnThumbColor: colors.gray[900],
    bgOffThumbColor: colors.gray[900],
  },
  modal: {
    bgColor: colors.gray[800],
    bgBorderColor: colors.gray[700],
    bgColorContent: '#262831',
  },
  alerts: {
    danger: colors.red[500],
    info: colors.blue[500],
    success: colors.green[500],
    warning: colors.yellow[500],
  },
  chart: {
    success: colors.green[500],
    warning: colors.yellow[400],
    danger: colors.red[500],
    grayColor: colors.gray[600],
    lowBatteryLine: colors.red[400],
    chartLines: colors.gray[800],
    chartBars: colors.gray[400],
    bgTooltipColor: colors.gray[300],
    bgColorSecondaryText: colors.gray[900],
  },
  map: {
    buttonColor: colors.gray[800],
    buttonIconColor: 'white',
    buttonDisabledIconColor: colors.gray[500],
  },
  codeInput: {
    successBorderColor: colors.green[500],
    errorBorderColor: colors.red[800],
    defaultBorderColor: '#FFFFFF',
    bgColor: colors.gray[800],
  },
  appointment: {
    progress: (opacity: number) => `rgba(255, 255, 255, ${opacity})`,
  },
  pagination: {
    activeDotColor: colors.gray[400],
    inactiveDotColor: colors.gray[700],
  },
  payments: {
    bgColor: colors.gray[900],
    borderColor: colors.gray[600],
    separatorColor: colors.gray[600],
    gradientColor: {
      gradientOne: '#D9C7E7',
      gradientTwo: '##B68DD64D',
    },
  },
  tourGuide: {
    bgTooltipColor: colors.gray[700],
    textColor: 'white',
  },
  radio: {
    bgBorderColor: 'white',
    bgColor: 'transparent',
  },
  card: {
    dividerColor: colors.gray[700],
    bgBorderColor: colors.gray[700],
    bgColor: colors.gray[800],
    bgColorSecondary: colors.gray[600],
    bgMapColor: '#0A0C0E',
    shockDetectionOneColor: colors.red[600],
    shockDetectionTwoColor: colors.orange[600],
    shockDetectionThreeColor: colors.yellow[500],
    dividerShockDetectionOneColor: colors.red[900],
    dividerShockDetectionTwoColor: colors.orange[900],
    dividerShockDetectionThreeColor: colors.yellow[600],
  },
  navbar: {
    bgColor: colors.gray[800],
  },
  dots: {
    bgActive: colors.gray[400],
    bgInActive: colors.gray[700],
  },
  customButtons: {
    bgBorderColor: colors.gray[400],
    bgIconColor: colors.gray[300],
    bgTextColor: colors.gray[300],
    bgHoverColor: colors.gray[400],
    bgHoverIconColor: 'black',
    bgHoverText: 'black',
  },
  divider: {
    primaryColor: colors.gray[700],
  }
}
